import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import locale from '@glu/locale';
import {
  ValidatedInput as Input,
  defaultStrings_en_US as defaultStringsEnUs
} from '@glu/form-components';
import LocaleContext from '../../../locale';
import { validateMapName } from '../../../../api/payments/service';
import { validateLength } from './utils';
import { HEADER_FIELDS } from './constants';

locale.set(defaultStringsEnUs);

const MapNameInputComponent = ({
  dataQa,
  disabled,
  initialData,
  label,
  maxLengthIndicatorLimit,
  name,
  onChange,
  registerValidators,
  ...props
}) => {
  const locale = useContext(LocaleContext);

  const validateMapNameFunc = useCallback(
    async (name, _, data) => {
      if (!data[name]) return true;

      if (maxLengthIndicatorLimit && data[name]?.length > maxLengthIndicatorLimit) return true;

      if (initialData[HEADER_FIELDS.MAP_NAME] === data[name]) {
        return true;
      }

      const { data: response } = await validateMapName(data[name]).toPromise();
      return !response?.isMapNameExist;
    },
    [maxLengthIndicatorLimit, initialData]
  );

  const asyncMapNameExistenceValidator = {
    fn: validateMapNameFunc,
    msg: locale['wireImports.mapNameMustBeUnique']
  };

  return (
    <Input
      name={name}
      className="form-group"
      data-qa={dataQa || name}
      labelText={label}
      disabled={disabled}
      validators={[
        asyncMapNameExistenceValidator,
        { required: true, msg: locale['validation.required'] },
        ...(maxLengthIndicatorLimit ? [validateLength(maxLengthIndicatorLimit, locale)] : [])
      ]}
      maxLengthIndicatorLimit={maxLengthIndicatorLimit}
      validateBlurOnly
      {...props}
    />
  );
};

MapNameInputComponent.propTypes = {
  dataQa: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  registerValidators: PropTypes.func,
  disabled: PropTypes.bool,
  maxLengthIndicatorLimit: PropTypes.number,
  initialData: PropTypes.shape({})
};

MapNameInputComponent.defaultProps = {
  initialData: {},
  onChange() {},
  label: null,
  registerValidators() {},
  disabled: false,
  maxLengthIndicatorLimit: null
};

export default MapNameInputComponent;
